import { REPORT_TYPES_SLOT } from './relatorios'

export default [
  {
    key: 'dashboard',
    icon: 'mdi-view-dashboard',
    title: 'Dashboard',
    to: '/gestor/dashboard',
  },
  {
    key: 'cronograma-financeiro-grupo',
    icon: 'mdi-cash',
    title: 'Cronograma Financeiro',
    group: '/gestor',
    children: [
      {
        key: 'financeiro',
        icon: 'mdi-account-hard-hat',
        title: 'Cronograma Financeiro',
        to: 'financeiro',
      },
      {
        key: 'odometer',
        icon: 'mdi-car',
        title: 'Lançamento de percurso',
        to: 'odometer',
      },
    ],
  },
  {
    key: 'pessoas-grupo',
    icon: 'mdi-account-multiple',
    title: 'Pessoas',
    group: '/gestor',
    children: [
      {
        key: 'consultores',
        icon: 'mdi-account-hard-hat',
        title: 'Consultores',
        to: 'consultores',
      },
      {
        key: 'fazendas',
        icon: 'mdi-home-flood',
        title: 'Fazendas',
        to: 'fazendas',
      },
      {
        key: 'prestador',
        icon: 'mdi-account',
        title: 'Prestadores',
        to: 'prestador',
      },
      {
        key: 'produtores',
        icon: 'mdi-account-cowboy-hat',
        title: 'Produtores',
        to: 'produtores',
      },
      {
        key: 'central',
        icon: 'mdi-account-cog',
        title: 'Supervisor',
        to: 'central',
      },
    ],
  },
  {
    key: 'relatorios-grupo',
    icon: 'mdi-clipboard-list',
    title: 'Relatórios',
    group: '/gestor/relatorios',
    children: [
      {
        key: 'gerenciais-grupo',
        title: 'Gerenciais',
        group: '/gestor/relatorios',
        children: [
          {
            key: 'visitas',
            icon: 'mdi-file-document-edit',
            title: 'Visitas por Consultor',
            to: 'visitas',
          },
          {
            key: 'deslocamento',
            icon: 'mdi-clipboard-list',
            title: 'Deslocamento de Consultores',
            to: 'deslocamento',
          },
          {
            key: 'sinc',
            icon: 'mdi-clipboard-list',
            title: 'Sincronização de Visitas',
            to: 'sinc',
          },
          {
            key: 'entrega',
            icon: 'mdi-file-document-edit',
            title: 'Entrega de Material',
            to: 'entrega',
          },
        ],
      },
      {
        key: 'visitas-grupo',
        subicon: 'mdi-clipboard-list',
        title: 'Visitas',
        group: '/gestor/relatorios',
        children: [
          REPORT_TYPES_SLOT,
          {
            key: 'entregas',
            icon: 'mdi-clipboard-multiple',
            title: 'Entregas de Material',
            to: 'entregas',
          },
        ],
      },
    ],
  },
]
